<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    totalItems () {
      return this.campsiteBookings.length + this.parkingBookings.length + this.gatePasses.length + this.otherCharges.length
    },
    ...mapGetters({
      campsiteBookings: 'cart/campsiteBookings',
      parkingBookings: 'cart/parkingBookings',
      gatePasses: 'cart/gatePasses',
      otherCharges: 'cart/otherCharges'
    })
  },
  watch: {
    totalItems: {
      handler (val) {
        if (!val) {
          this.$router.push({ path: '/' })
        }
      },
      deep: true
    }
  }
}
</script>
